/**
 * @generated SignedSource<<0cf2273c7060c6ad21e4e16b0410d60d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SearchLinkedResultCategory = "child" | "mentionedBy" | "mentions" | "similar" | "%future added value";
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "code" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "organization" | "organization_status_update" | "page" | "plan" | "playlist" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "risk" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchGraphCase_AtlassianSearchPage$data = {
  readonly entity: {
    readonly closedAt?: string | null;
    readonly container?: {
      readonly displayName?: string | null;
      readonly id?: string;
    } | null;
    readonly createdBy?: {
      readonly thirdPartyUser: {
        readonly name: string | null;
      } | null;
    } | null;
    readonly displayNumber?: string | null;
    readonly lastUpdated?: string | null;
    readonly owners?: ReadonlyArray<{
      readonly thirdPartyUser: {
        readonly name: string | null;
      } | null;
      readonly user: {
        readonly name: string;
      } | null;
    } | null> | null;
    readonly status?: string | null;
  } | null;
  readonly excerpt: string | null;
  readonly id: string;
  readonly lastModifiedDate: string | null;
  readonly linkedEntities?: ReadonlyArray<{
    readonly entity: {
      readonly displayName?: string | null;
    } | null;
    readonly excerpt: string | null;
    readonly id: string;
    readonly parentId: string | null;
    readonly url: string;
  }> | null;
  readonly linkedResults: ReadonlyArray<{
    readonly category: SearchLinkedResultCategory;
    readonly connectorType: string | null;
    readonly description: string;
    readonly id: string;
    readonly integrationId: string | null;
    readonly lastModifiedDate: string | null;
    readonly providerId: string | null;
    readonly subtype: string | null;
    readonly title: string;
    readonly type: SearchResultType;
    readonly url: string;
  }> | null;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "searchGraphCase_AtlassianSearchPage";
};
export type searchGraphCase_AtlassianSearchPage$key = {
  readonly " $data"?: searchGraphCase_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphCase_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "url"
},
v2 = {
  "kind": "ScalarField",
  "name": "title"
},
v3 = {
  "kind": "ScalarField",
  "name": "lastModifiedDate"
},
v4 = {
  "kind": "ScalarField",
  "name": "excerpt"
},
v5 = [
  {
    "kind": "ScalarField",
    "name": "name"
  }
],
v6 = {
  "concreteType": "ThirdPartyUser",
  "kind": "LinkedField",
  "name": "thirdPartyUser",
  "plural": false,
  "selections": (v5/*: any*/)
},
v7 = {
  "kind": "ScalarField",
  "name": "displayName"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeCaseEmbeddedComments"
    }
  ],
  "kind": "Fragment",
  "name": "searchGraphCase_AtlassianSearchPage",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/),
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "displayNumber"
            },
            {
              "kind": "ScalarField",
              "name": "status"
            },
            {
              "kind": "ScalarField",
              "name": "closedAt"
            },
            {
              "kind": "ScalarField",
              "name": "lastUpdated"
            },
            {
              "concreteType": "ExternalUser",
              "kind": "LinkedField",
              "name": "owners",
              "plural": true,
              "selections": [
                (v6/*: any*/),
                {
                  "kind": "LinkedField",
                  "name": "user",
                  "plural": false,
                  "selections": (v5/*: any*/)
                }
              ]
            },
            {
              "concreteType": "ExternalUser",
              "kind": "LinkedField",
              "name": "createdBy",
              "plural": false,
              "selections": [
                (v6/*: any*/)
              ]
            },
            {
              "kind": "LinkedField",
              "name": "container",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v0/*: any*/),
                    (v7/*: any*/)
                  ],
                  "type": "ExternalCustomerOrg"
                }
              ]
            }
          ],
          "type": "ExternalCase"
        }
      ]
    },
    {
      "condition": "includeCaseEmbeddedComments",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "SearchResultGraphDocument",
          "kind": "LinkedField",
          "name": "linkedEntities",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "name": "parentId"
            },
            (v4/*: any*/),
            (v1/*: any*/),
            {
              "kind": "LinkedField",
              "name": "entity",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v7/*: any*/)
                  ],
                  "type": "ExternalComment"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "concreteType": "SearchLinkedResult",
      "kind": "LinkedField",
      "name": "linkedResults",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v2/*: any*/),
        (v1/*: any*/),
        {
          "kind": "ScalarField",
          "name": "type"
        },
        {
          "kind": "ScalarField",
          "name": "description"
        },
        (v3/*: any*/),
        {
          "kind": "ScalarField",
          "name": "category"
        },
        {
          "kind": "ScalarField",
          "name": "subtype"
        },
        {
          "kind": "ScalarField",
          "name": "integrationId"
        },
        {
          "kind": "ScalarField",
          "name": "providerId"
        },
        {
          "kind": "ScalarField",
          "name": "connectorType"
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "da7bf140a9e1fcc07b356036438c871d";

export default node;
